<div class="main-content">
  <mat-toolbar class="bg-white mat-toolbar-override">
    <button
      mat-icon-button
      (click)="back()"
      id="visitor_type_management_add_edit_back_btn"
    >
      <mat-icon color="primary"> keyboard_backspace </mat-icon>
    </button>
  </mat-toolbar>

  <div class="header">
    <h1>
      {{
        (!isEditMode
          ? "visitor_type_management_add_edit_add_header"
          : "visitor_type_management_add_edit_edit_header"
        ) | translate
      }}
    </h1>
  </div>
  <label class="details">
    {{ "visitor_type_management_add_edit_details" | translate }}
  </label>
  <form [formGroup]="formGroup">
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "visitor_type_management_add_edit_form_lbl_description"
                  | translate
              }}
            </mat-label>
            <input
              matInput
              placeholder="{{
                'visitor_type_management_add_edit_form_lbl_description'
                  | translate
              }}"
              formControlName="description"
              required
              id="input_description"
            />
            @if (hasError(formGroup, 'description')) {
            <mat-error>
              {{
                "visitor_type_management_add_edit_error_visitor_types_description_validator"
                  | translate
              }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        @for (lang of languages; track lang) {
        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "visitor_type_management_add_edit_form_lbl_description"
                  | translate
              }}
              {{ lang.description }}
            </mat-label>
            <input
              matInput
              placeholder="{{
                'visitor_type_management_add_edit_form_lbl_description'
                  | translate
              }}"
              formControlName="{{ lang.code.replace('-', '_') }}"
              id="input_description_{{ lang.code.replace('-', '_') }}"
            />
          </mat-form-field>
        </div>
        }

        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "visitor_type_management_add_edit_form_lbl_brand" | translate
              }}
            </mat-label>
            <mat-select
              placeholder="{{
                'visitor_type_management_add_edit_form_lbl_brand' | translate
              }}"
              formControlName="brand"
              required
              id="input_brand"
              [(value)]="selectedBrandName"
            >
              @for (brand of existingBrands; track brand) {
              <mat-option [value]="brand.name">
                {{ brand.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "visitor_type_management_add_edit_form_lbl_domain" | translate
              }}
            </mat-label>
            <mat-select
              placeholder="{{
                'visitor_type_management_add_edit_form_lbl_domain' | translate
              }}"
              formControlName="domain"
              id="input_domain"
              [(value)]="selectedDomainName"
            >
              @for (domain of existingDomains; track domain) {
              <mat-option [value]="domain.name">
                {{ domain.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="input-field">
          <mat-checkbox class="color-city-blue" formControlName="isActive">
            {{
              "visitor_type_management_visitor_type_isactive_header" | translate
            }}
          </mat-checkbox>
        </div>

        @if (isEditMode || isVisitorTypeCreated) {
        <div class="item-table">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between end"
            fxLayout="row wrap"
          >
            <h5>
              {{ "visitor_type_management_add_edit_list_header" | translate
              }}<mat-icon>help_outline</mat-icon>
            </h5>
            <div fxLayoutAlign="center center" fxLayout="row wrap">
              <div class="filter-box checkbox" fxLayoutAlign="start baseline">
                <mat-checkbox
                  class="color-city-blue"
                  [(ngModel)]="selectedIsActive"
                  (change)="onFilterChange(REASON_VISIT)"
                  [ngModelOptions]="{ standalone: true }"
                >
                  {{
                    "visitor_type_management_visitor_type_isactive_header"
                      | translate
                  }}
                </mat-checkbox>
              </div>
              @if (showSearchButton(REASON_VISIT)) {
              <button
                data-testid="visitor_type_management_list_search_icon"
                mat-fab
                color="primary"
                style="margin-right: 1em; width: 4em"
                (click)="openSearch(REASON_VISIT)"
              >
                <mat-icon>search</mat-icon>
              </button>
              } @if (showSearchInput(REASON_VISIT)) {
              <div>
                <mat-form-field
                  style="margin-right: 1em"
                  fxLayoutAlign="end end"
                >
                  <mat-label>{{
                    "visitor_type_management_add_edit_search_label" | translate
                  }}</mat-label>
                  <input
                    matInput
                    data-testid="visitor_type_management_list_search_input"
                    type="text"
                    [formControl]="searchControl"
                    placeholder="{{
                      'visitor_type_management_add_edit_search_label'
                        | translate
                    }}"
                    (keydown)="onSearchInputKeydown($event)"
                  />
                  <button
                    data-testid="visitor_type_management_list_close_search_icon"
                    matSuffix
                    mat-icon-button
                    (click)="closeSearch(REASON_VISIT)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              }
              <button
                id="btn_add_reasonForVisit"
                data-testid="visitor_type_management_list_add"
                mat-fab
                color="primary"
                type="button"
                style="width: 4em"
                (click)="addNewReasonForVisit()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="divider"></div>
          <mat-divider class="table-divider-header"></mat-divider>
          <div>
            <table
              mat-table
              data-testid="visitor_type_management_list_top_table"
              [dataSource]="dataSource"
              matSort
              (matSortChange)="onSortChange($event, REASON_VISIT)"
            >
              <ng-container matColumnDef="Description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="80"
                  fxLayoutAlign="start center"
                  mat-sort-header
                  sortActionDescription="Sort by description"
                >
                  {{
                    "visitor_type_management_add_edit_description_column_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  class="color-dark-blue"
                  *matCellDef="let reason"
                  fxFlex="80"
                  fxLayoutAlign="start center"
                >
                  <span class="ellipsis"
                    >{{ reason.description }}
                    @for (tran of reason.translations; track tran) {
                    <span>| {{ tran.description }} </span>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="IsActive">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="10"
                  fxLayoutAlign="center center"
                  mat-sort-header
                  sortActionDescription="Sort by isActive"
                >
                  {{
                    "visitor_type_management_visitor_type_isactive_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  class="color-dark-blue"
                  *matCellDef="let reason"
                  fxFlex="10"
                  fxLayoutAlign="center center"
                >
                  <span class="ellipsis">
                    @if (reason.isActive) {
                    <mat-icon class="color-city-green">task_alt</mat-icon>
                    } @if (!reason.isActive) {
                    <mat-icon class="color-city-red">close</mat-icon>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="5"
                  fxLayoutAlign="center center"
                >
                  {{
                    "visitor_type_management_add_edit_actions_column_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let reason"
                  fxFlex="5"
                  fxLayoutAlign="start center"
                >
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    style="width: 100%"
                  >
                    <mat-icon
                      matTooltip="{{ editToolTip }}"
                      id="visitor_type_management_list_edit_icon"
                      data-testid="visitor_type_management_list_edit_icon"
                      color="primary"
                      (click)="editReasonForVisit(reason)"
                    >
                      edit
                    </mat-icon>
                    <!--mat-icon matTooltip="{{deleteToolTip}}"
                              id="visitor_type_management_list_delete_icon"
                              data-testid="visitor_type_management_list_delete_icon" color="primary"
                              (click)="deleteReasonForVisit(reason)">
                              delete
                            </mat-icon-->
                  </div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedReasonForVisitColumns"
              ></tr>
              <tr
                mat-row
                *matRowDef="
                  let element;
                  columns: displayedReasonForVisitColumns
                "
                class="element-row"
              ></tr>
            </table>
            <mat-paginator
              #paginator
              [pageSize]="pageSize"
              [pageSizeOptions]="[10, 20, 50]"
              [length]="totalItems"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
        } @if (isEditMode || isVisitorTypeCreated) {
        <div class="item-table">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between end"
            fxLayout="row wrap"
          >
            <h5>
              {{
                "visitor_type_management_reason_for_visit_addEdit_update_reason_list_header"
                  | translate
              }}<mat-icon>help_outline</mat-icon>
            </h5>
            <div fxLayoutAlign="center center" fxLayout="row wrap">
              <div class="filter-box checkbox" fxLayoutAlign="start baseline">
                <mat-checkbox
                  class="color-city-blue"
                  [(ngModel)]="selectedUploadReasonIsActive"
                  (change)="onFilterChange(UPLOAD_REASON)"
                  [ngModelOptions]="{ standalone: true }"
                >
                  {{
                    "visitor_type_management_visitor_type_isactive_header"
                      | translate
                  }}
                </mat-checkbox>
              </div>
              @if (showSearchButton(UPLOAD_REASON)) {
              <button
                data-testid="reason_upload_management_list_search_icon"
                mat-fab
                color="primary"
                style="margin-right: 1em; width: 4em"
                (click)="openSearch(UPLOAD_REASON)"
              >
                <mat-icon>search</mat-icon>
              </button>
              } @if (showSearchInput(UPLOAD_REASON)) {
              <div>
                <mat-form-field
                  style="margin-right: 1em"
                  fxLayoutAlign="end end"
                >
                  <mat-label>{{
                    "visitor_type_management_search_label" | translate
                  }}</mat-label>
                  <input
                    matInput
                    data-testid="reason_upload_management_list_search_input"
                    type="text"
                    [formControl]="uploadReasonSearchControl"
                    placeholder="{{
                      'visitor_type_management_search_label' | translate
                    }}"
                    (keydown)="onSearchInputKeydown($event)"
                  />
                  <button
                    data-testid="upload_reason_management_list_close_search_icon"
                    matSuffix
                    mat-icon-button
                    (click)="closeSearch(UPLOAD_REASON)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              }
              <button
                id="btn_add_reasonupload"
                data-testid="reason_upload_management_list_add"
                mat-fab
                color="primary"
                style="width: 4em"
                (click)="addNewUploadReason()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="divider"></div>
          <mat-divider class="table-divider-header"></mat-divider>
          <div>
            <table
              mat-table
              data-testid="reason_upload_management_list_top_table"
              [dataSource]="uploadReasonDataSource"
              matSort
              (matSortChange)="onSortChange($event, UPLOAD_REASON)"
            >
              <ng-container matColumnDef="Description">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="85"
                  fxLayoutAlign="start center"
                  mat-sort-header
                  sortActionDescription="Sort by description"
                >
                  {{
                    "visitor_type_management_visitor_type_description_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  class="color-dark-blue"
                  *matCellDef="let displayedUploadReason"
                  fxFlex="85"
                  fxLayoutAlign="start center"
                >
                  <span class="ellipsis">{{
                    displayedUploadReason.description
                  }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="IsActive">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="10"
                  fxLayoutAlign="center center"
                  mat-sort-header
                  sortActionDescription="Sort by isActive"
                >
                  {{
                    "visitor_type_management_visitor_type_isactive_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  class="color-dark-blue"
                  *matCellDef="let displayedUploadReason"
                  fxFlex="10"
                  fxLayoutAlign="center center"
                >
                  <span class="ellipsis">
                    @if (displayedUploadReason.isActive) {
                    <mat-icon class="color-city-green">task_alt</mat-icon>
                    } @if (!displayedUploadReason.isActive) {
                    <mat-icon class="color-city-red">close</mat-icon>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  fxFlex="5"
                  fxLayoutAlign="center center"
                >
                  {{
                    "visitor_type_management_visitor_type_actions_header"
                      | translate
                  }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let displayedUploadReason"
                  fxFlex="5"
                  fxLayoutAlign="center center"
                >
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    style="width: 100%"
                  >
                    <mat-icon
                      matTooltip="{{ editToolTip }}"
                      id="visitor_type_management_list_edit_icon"
                      data-testid="visitor_type_management_list_edit_icon"
                      color="primary"
                      (click)="editUploadReason(displayedUploadReason)"
                    >
                      edit
                    </mat-icon>
                  </div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedUploadReasonColumns"
              ></tr>
              <tr
                mat-row
                *matRowDef="let element; columns: displayedUploadReasonColumns"
                class="element-row"
              ></tr>
            </table>
            <mat-paginator
              #uploadReasonPaginator
              [pageSize]="uploadReasonPageSize"
              [pageSizeOptions]="[10, 20, 50]"
              [length]="uploadReasonTotalItems"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
        }

        <div
          class="button-grp"
          fxLayout="column"
          fxFlex="100%"
          fxLayoutGap="1em"
        >
          <button
            id="btn_save"
            mat-raised-button
            (click)="saveOnClick()"
            type="submit"
            [disabled]="disableSaveOnClick() || isVisitorTypeCreated"
          >
            {{ "visitor_type_management_add_edit_save_btn" | translate }}
          </button>
          <button id="btn_cancel" mat-raised-button (click)="closeOnClick()">
            {{ "visitor_type_management_add_edit_close_btn" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
